import React, { Component } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';

const Async = (getComponent) => {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);
      this.Component = null;
      this.state = {
        Component: this.Component
      }
    }

    componentWillMount() {
      if (!this.state.Component) {
        getComponent()
          .then(Component => {
            AsyncComponent.Component = Component;
            this.setState({ Component })
          })
      }
    }

    render() {
      const { Component } = this.state;

      return Component
        ? <Component {...this.props} />
        : <Grid container justify='center' alignItems='center' style={{ height: '100vh' }}><CircularProgress size={44} color='secondary' /></Grid>
    }
  }

  return AsyncComponent
}

export default Async


// WEBPACK FOOTER //
// ./src/components/hocs/AsyncComponent.js